import { message } from "antd";

export const sendKOTPrintJob = async (
  printPayload: any,
  serverUrl?: string,
): Promise<boolean> => {
  if (!printPayload) return true;
  const baseUrl = serverUrl || "http://localhost:5100";
  try {
    const res = await fetch(`${baseUrl}/print`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(printPayload),
    });
    if (!res.ok) {
      message.warning("KOT sent but printer returned an error.");
      return false;
    }
    return true;
  } catch (err) {
    console.error("Printer fetch error:", err);
    message.warning("Could not reach the local KOT printer server.");
    return false;
  }
};
